import { Storage, Auth, Analytics } from "aws-amplify";
import { APP_BUCKET, APP_BUCKET_REGION, COGNITO_REGION, SUPPLIER_BUCKET, identityPoolId, userPoolId, userPoolWebClientId, US_BUCKET_REGION, US_BUCKET } from "./aws.config";

export const awsExports = {

  Auth: {
    identityPoolId: identityPoolId,
    region: APP_BUCKET_REGION,
    userPoolId: userPoolId,
    userPoolWebClientId: userPoolWebClientId,
  },

  Storage: {
    AWSS3: {
      bucket: APP_BUCKET,
      region: APP_BUCKET_REGION,
      level: 'public'
    },
  },
  SupplierStorage: {
    AWSS3: {
      bucket: SUPPLIER_BUCKET,
      region: COGNITO_REGION,
    },
    level: 'public'
  }
};

export const SetS3Config = () => {
  Auth.configure(awsExports);
  Analytics.configure({ disabled: true });
  Storage.configure({
    bucket: APP_BUCKET,
    level: "public",
    region: APP_BUCKET_REGION,
    identityPoolId: identityPoolId
  });
}
